import { merchantApi } from "@api";
import { selectAuth, selectMerchant } from "@redux";
import { formatMessage, useNotify } from "@utils";
import { Button, Input, Select } from "antd";
import { useEffect, useState } from "react";
import Barcode from "react-barcode";
import { useTranslation } from "react-i18next";
import QRCode from "react-qr-code";
import { useSelector } from "react-redux";
import { formatDate } from "src/Utils/dateUtil";
import styled from "styled-components";
import "swiper/components/navigation/navigation.min.css";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper-bundle.min.css";
import "swiper/swiper.min.css";
import { IConClose, IconBack } from "./icon";
const { Option } = Select;

interface ICard {
    cardId: string;
    cardCash: string;
    cardExp: string;
    cardNumber: string;
    imageUrl: string[];
    secretNumber: string;
    isDefault: boolean;
    isDelete: boolean;
    isOnline: boolean;
    isTopup: boolean;
    isAllmember: boolean;
    initialAmount: number;
    maxUsePertime: number;
    isFreeze: boolean;
}

interface IProps {
    isShow: boolean;
    handleCloseDetail: () => void;
    openPaymentProcess?: () => void;
    cardDetail: ICard;
    cardList: ICard[];
    focusIndex: number;
    type: string;
}

export const ComponentPaymentDrwaer = (props: IProps) => {
    //page hooks
    const { t } = useTranslation();
    const { error, success, warning } = useNotify();
    let { isShow, handleCloseDetail, cardDetail, cardList, focusIndex, type, openPaymentProcess } =
        props;
    //redux states
    const { themes } = useSelector(selectMerchant);
    const { showConfirm, userInfo } = useSelector(selectAuth);
    const merchant = useSelector(selectMerchant);
    const staticQuestion = merchant.signUpSettings?.staticQuestion;

    const [currentIndex, setCurrentIndex] = useState<number>(0);
    const [isConfirm, setIsConfirm] = useState<boolean>(false);
    const [swiperRef, setSwiperRef] = useState<any>(null);
    const [step, setStep] = useState<number>(1);
    const [price, setPrice] = useState<number | string>("");

    console.log("cardList", cardList);

    //page redux

    useEffect(() => {
        if (type === "used-list") {
            setStep(3);
        }
        console.log("url ==>", window.location.href);
    }, [type]);

    useEffect(() => {
        console.log("cardDetail =>", cardDetail);
        if (isShow) {
            setCurrentIndex(focusIndex);
            slideTo(focusIndex);
        }
    }, [isShow]);

    useEffect(() => {
        if (swiperRef !== null) {
            slideTo(focusIndex);
        }
    }, [swiperRef]);

    const onSlideChange2 = (e: any) => {
        setCurrentIndex(e.activeIndex as number);
    };

    const slideTo = (index: number) => {
        swiperRef?.slideTo(index, 0);
    };

    const changePriceAmount = (e: any) => {
        if (!isNaN(+e.target.value)) {
            setPrice(e.target.value);
        }
    };

    const handleConfirm = async () => {
        if (Number(price)) {
            try {
                const res = await merchantApi.paymentTopUp({
                    organization_id: merchant._id || "",
                    profile_id: userInfo?._id || "",
                    loyalty_card_id: cardDetail.cardId,
                    loyalty_topup_amount: Number(price),
                    loyalty_topup_discount: 0,
                    // store_id: "61d7f8d8332169bdd44112f5",
                    return_url: window.location.href,
                });
                console.log(res);
                if (res.data.error === "0") {
                    window.open(res.data.result?.pay_link, "_self");
                    handleCloseDetail();

                    setStep(1);
                } else {
                    warning(res.data.msg);
                }
                // setPrice("");
                // success("payment success");
            } catch (err: any) {
                warning(formatMessage(err.response));
            } finally {
                setPrice("");
            }
        } else {
            warning("please add price");
        }
    };

    const isCardExpired = (cardExp: string): boolean => {
        if (!cardExp) return false;
        const expirationDate = new Date(cardExp);
        const currentDate = new Date();
        return expirationDate < currentDate;
    };

    const addPrice = (addPrice: number) => {
        let num = Number(price) || 0;
        num = num + addPrice;
        setPrice(num);
    };
    return (
        <StyledContainerHistoryDetailDone isConfirm={isConfirm} themeColor={themes?.themeColor!}>
            <div className="header">
                <div className="confirmation text-sub-header"></div>

                <div className="close" onClick={handleCloseDetail}>
                    <IConClose />
                </div>
            </div>
            {step === 1 && (
                <div className="content-layout">
                    <StyledCardDetail themeColor={themes?.themeColor!}>
                        <div className="step1">
                            <h1>{t("page.card.select_channel_payment")}</h1>
                            {cardDetail.isTopup && (
                                <div className="payment-item" onClick={() => setStep(2)}>
                                    <div className="img-section">
                                        <img src="/images/payment_credit.png" />
                                        <img src="/images/payment_promptpay.png" />
                                    </div>
                                    <p>{t("page.card.online_payment")}</p>
                                </div>
                            )}
                            <div className="payment-item big-payment" onClick={() => setStep(3)}>
                                <div className="img-section">
                                    <img src="/images/payment_store.png" className="big-img" />
                                </div>
                                <p>{t("page.card.store_payment")}</p>
                            </div>
                        </div>
                    </StyledCardDetail>
                </div>
            )}
            {step === 2 && (
                <div className="content-layout">
                    <StyledCardDetail themeColor={themes?.themeColor!}>
                        <div className="step2">
                            <h1>
                                <span onClick={() => setStep(1)}>
                                    {" "}
                                    <IconBack />
                                </span>
                                &nbsp; {t("page.card.select_channel_payment")}
                            </h1>
                            <p className="title">
                                {t("page.card.enter_amount")} ({t("page.card.thb")})
                            </p>
                            <Input
                                className="input-amount"
                                value={price}
                                onChange={(e) => changePriceAmount(e)}
                            />
                            <div className="price-list-section">
                                <Button className="price-btn" onClick={() => addPrice(100)}>
                                    + 100
                                </Button>
                                <Button className="price-btn" onClick={() => addPrice(500)}>
                                    + 500
                                </Button>
                                <Button className="price-btn" onClick={() => addPrice(900)}>
                                    + 900
                                </Button>
                                <Button className="price-btn" onClick={() => addPrice(1000)}>
                                    + 1,000
                                </Button>
                            </div>
                            <Button className="pay-btn" onClick={handleConfirm}>
                                {t("page.confirm")}
                            </Button>
                        </div>
                    </StyledCardDetail>
                </div>
            )}
            {step === 3 && (
                <div className="content-layout">
                    <StyledCardDetail themeColor={themes?.themeColor!}>
                        <div className="wrapper-main-detail-card">
                            {cardList.length === 0 ? (
                                <Swiper
                                    slidesPerView={1.1}
                                    onSlideChange={onSlideChange2}
                                    pagination={true}
                                    onSwiper={(s) => {
                                        setSwiperRef(s);
                                    }}
                                >
                                    {cardList.map((item: any, index: any) => (
                                        <SwiperSlide key={index}>
                                            <div className="layout-main-detail-card">
                                                <div className="layout-card-membercard">
                                                    {cardList[currentIndex]?.isFreeze && (
                                                        <div className="cardshow-expired">
                                                            <span>
                                                                <img
                                                                    src="../images/ic-lock.svg"
                                                                    alt=""
                                                                />
                                                            </span>
                                                            Your card has been freeze.
                                                        </div>
                                                    )}
                                                    <img src={item?.imageUrl?.[0]} />
                                                    <div className="text-card-membercard"></div>
                                                </div>
                                            </div>
                                        </SwiperSlide>
                                    ))}
                                </Swiper>
                            ) : (
                                <Swiper
                                    slidesPerView={1}
                                    onSlideChange={onSlideChange2}
                                    pagination={true}
                                    onSwiper={(s) => {
                                        setSwiperRef(s);
                                    }}
                                >
                                    {cardList.map((item: any, index: any) => (
                                        <SwiperSlide key={index}>
                                            <div className="layout-main-detail-card">
                                                <div className="layout-card-membercard">
                                                    {cardList[currentIndex]?.isFreeze && (
                                                        <div className="cardshow-expired">
                                                            <span>
                                                                <img
                                                                    src="../images/ic-lock.svg"
                                                                    alt=""
                                                                />
                                                            </span>
                                                            Your card has been freeze.
                                                        </div>
                                                    )}
                                                    <img src={item?.imageUrl?.[0]} />
                                                    <div className="text-card-membercard"></div>
                                                </div>
                                            </div>
                                        </SwiperSlide>
                                    ))}
                                </Swiper>
                            )}
                        </div>
                        <div className="layout-expire">
                            <div className="status">
                                {cardList[currentIndex]?.isFreeze && (
                                    <span className="freeze">{t("page.freeze")}</span>
                                )}
                                {isCardExpired(cardList[currentIndex]?.cardExp) && (
                                    <span className="expire">{t("page.expired")}</span>
                                )}
                            </div>
                            {cardList[currentIndex]?.cardExp && (
                                <div className="show-expiredate">
                                    <div className="title">Gift Card Expired Data :</div>
                                    <span>{formatDate(cardList[currentIndex]?.cardExp)}</span>
                                </div>
                            )}
                        </div>
                        <div className="barcode-section">
                            <Barcode
                                value={cardList[currentIndex]?.cardNumber}
                                displayValue={false}
                                height={40}
                            />
                            <p>{cardList[currentIndex]?.cardNumber}</p>
                        </div>
                        <div className="qr-section">
                            <QRCode value={cardList[currentIndex]?.cardNumber || ""} size={120} />
                        </div>
                    </StyledCardDetail>
                </div>
            )}
        </StyledContainerHistoryDetailDone>
    );
};

const StyledCardDetail = styled.div<{ themeColor: string }>`
    text-align: center;
    .swiper-pagination-bullet {
        background-color: ${(p) => p.themeColor};
    }
    .layout-main-detail-card {
        padding: 0px 8px;
        margin: 0 8px 5px 4px;
        .layout-card-membercard {
            position: relative;
            .cardshow-expired {
                position: absolute;
                width: 100%;
                height: 100%;
                left: 0;
                top: 0;
                background-color: rgba(0, 0, 0, 0.74);
                z-index: 1;
                font-size: 12px;
                line-height: 15px;
                text-align: center;
                color: #fff;
                display: flex;
                align-items: center;
                justify-content: center;
                flex-direction: column;
                span {
                    margin-bottom: 10px;
                    img {
                        width: 22px;
                        height: 28px;
                    }
                }
            }
        }
    }
    img {
        width: 100%;
        height: 190px;
        object-fit: cover;
        border-radius: 20px;
        position: relative;
    }
    .barcode-section {
        margin: 5px 0px;
    }
    .layout-expire {
        margin: 5px 0;
        .status {
            margin-bottom: 10px;
            span {
                margin: 0 5px;
                padding: 4px 10px;
                background-color: #9daaae;
                border-radius: 50px;
                font-size: 12px;
                line-height: 15px;
            }
            span.expire {
                background-color: rgba(242, 47, 70, 0.12);
                color: #f22f46;
            }
            span.freeze {
                background-color: rgba(157, 170, 174, 0.2);
                color: #9daaae;
            }
        }
        .show-expiredate {
            .title {
                font-size: 14px;
                line-height: 17px;
                color: #9daaae;
                margin-bottom: 10px;
            }
            span {
                display: block;
                color: #946037;
                font-size: 24px;
                line-height: 27px;
                font-weight: 600;
            }
        }
    }
    .step1 {
        padding: 10px 20px;
        h1 {
            color: ${(p) => p.themeColor};
            font-size: 22px;
            font-weight: 500;
            text-align: left;
        }
        .payment-item {
            margin-top: 20px;
            display: flex;
            justify-content: space-around;
            border: 1px solid #9daaae;
            padding: 25px 15px;
            border-radius: 20px;
            cursor: pointer;
            .img-section {
                text-align: center;
                img {
                    height: 25px;
                    width: auto;
                    border-radius: 0px !important;
                    margin-right: 10px;
                }
                .big-img {
                    height: 50px;
                }
            }
            p {
                font-size: 18px;
                color: ${(p) => p.themeColor};
                margin-bottom: 0px;
            }
        }
        .big-payment {
            padding: 10px 20px;
            p {
                margin-top: 10px;
            }
        }
    }
    .step2 {
        padding: 0px 20px;
        h1 {
            color: ${(p) => p.themeColor};
            font-size: 22px;
            font-weight: 500;
            text-align: left;
        }
        .title {
            margin-top: 15px;
            margin-bottom: 5px;
            text-align: left;
            color: ${(p) => p.themeColor};
        }
        .input-amount {
            padding: 25px 10px;
            border-radius: 15px;
            border: 1px solid ${(p) => p.themeColor};
        }
        .price-list-section {
            display: grid;
            grid-template-columns: 1fr 1fr;
            grid-gap: 15px;
            margin-top: 20px;
            .price-btn {
                width: 100%;
                border-radius: 30px;
                height: 38px;
                border: 1px solid ${(p) => p.themeColor};
                color: ${(p) => p.themeColor};
                font-weight: bold;
            }
        }
        .pay-btn {
            margin-top: 40px;
            background-color: ${(p) => p.themeColor};
            height: 48px;
            width: 100%;
            color: #fff;
            border-radius: 50px;
        }
    }
`;

const StyledContainerHistoryDetailDone = styled.div<{ isConfirm: boolean; themeColor: string }>`
    height: 100vh;
    width: 100%;
    position: fixed;
    top: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 480px;
    background: rgba(0, 0, 0, 0.5);
    z-index: 10;
    left: 50%;
    transform: translateX(-50%);
    flex-direction: column;
    justify-content: end;
    transition: 2s !important;
    /* animation: opacity 0.5s!important; */
    @keyframes opacity {
        0% {
            opacity: 0;
        }
        100% {
            opacity: 1;
        }
    }

    .header {
        width: 100%;
        padding: 16px 24px;
        background: ${(p) => p.theme.colors.card};
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-radius: 8px 8px 0px 0px;
        color: inherit;
        /* animation: bottomtotop 1s!important; */
        position: relative;
        @keyframes bottomtotop {
            0% {
                top: 100%;
            }
            80% {
                top: -5%;
            }
            100% {
                top: 0%;
            }
        }
        .close {
            cursor: pointer;
            transform: rotate(0deg);
            transition: 0.6s;
            &:hover {
                transform: rotate(90deg);
            }
        }
    }
    .content-layout {
        height: ${(p) => (p.isConfirm === false ? `70vh` : "25vh")};
        background: ${(p) => p.theme.colors.white};
        /* padding-top: 24px; */
        /* padding-bottom: 24px; */
        width: 100%;
        /* animation: bottomtotop 1s!important; */
        position: relative;
        /* padding: 24px; */
        @keyframes bottomtotop {
            0% {
                top: 100%;
            }
            80% {
                top: -5%;
            }
            100% {
                top: 0%;
            }
        }
        @media (max-width: ${(p) => p.theme.breakPoints.breakMobileMax}) {
            overflow: scroll;
        }
        .confirm-section {
            .edit-icon {
                cursor: pointer;
                text-align: right;
            }
        }
        .save-btn {
            margin-top: 40px;
            width: 100%;
            height: 58px;
            border-radius: 50px;
            background-color: ${(p) => p.themeColor};
            color: white;
        }
    }
`;
